import { render, staticRenderFns } from "./capabilityReview.vue?vue&type=template&id=600ade21&scoped=true"
import script from "./capabilityReview.vue?vue&type=script&lang=js"
export * from "./capabilityReview.vue?vue&type=script&lang=js"
import style0 from "./capabilityReview.vue?vue&type=style&index=0&id=600ade21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ade21",
  null
  
)

export default component.exports